import styled from 'react-emotion';
import AUIList from '@ublend-npm/aulaui-next-web/List';

export const List = styled(AUIList)`
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 25%;
  height: 100%;
  padding-top: 0;
  padding-left: 0;
`;

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

export const MaterialContent = styled('div')`
  flex-basis: 75%;
  height: 100%;
`;
